import React from "react";

const variants = {
  primary:
    "bg-primary text-white hover:bg-primaryHover border border-primary/40 shadow-[0_0_0_1px_rgba(10,132,255,0.25)]",
  ghost: "bg-transparent text-muted hover:text-ink hover:bg-white/5 border border-transparent",
  outline: "bg-surface2 text-ink hover:bg-white/5 border border-line hover:border-lineFocus",
  danger: "bg-critical/10 text-critical hover:bg-critical/20 border border-critical/40",
};

const sizes = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-4 text-sm",
  lg: "h-11 px-6 text-sm",
  icon: "h-8 w-8 p-0",
};

export function Button({
  variant = "outline",
  size = "md",
  className = "",
  children,
  ...props
}) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-sm font-medium tracking-tight transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-40 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
